import { isString } from '@netpurpose/types'

type TransformValueMapping = {
  key: string
  // biome-ignore lint/suspicious/noExplicitAny: need to improve type
  transform: (v: any) => any
}

export type ReverseFieldMap<ModelKey extends PropertyKey> = Record<
  ModelKey,
  string | TransformValueMapping
>

type QueryMapper<Model> = (k: keyof Model, values: unknown[]) => [string, unknown[]]

const isTransformValueMapping = (v: unknown): v is TransformValueMapping => !isString(v)

export const getQueryMapper =
  <T>(reverseFieldMap: Partial<ReverseFieldMap<keyof T>>): QueryMapper<T> =>
  (k, values) => {
    const mapping = reverseFieldMap[k]

    if (!mapping) {
      throw new Error(`reverse field map not implemented for ${String(k)}`)
    }

    return isTransformValueMapping(mapping)
      ? [mapping.key as string, values.map((v) => mapping.transform(v))]
      : [mapping, values]
  }
